import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ClientRepository } from '../../../client.service';
import { ProjectListFilter, ProjectStatus } from '../../../models/project';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'cw-project-list-filter',
  templateUrl: './project-list-filter.component.html',
  styleUrls: ['./project-list-filter.component.scss']
})
export class ProjectListFilterComponent implements OnInit {
  @Input() filters: ProjectListFilter;
  @Output() changed: EventEmitter<ProjectListFilter> = new EventEmitter<ProjectListFilter>();

  statuses: any = [
    ProjectStatus.Active,
    ProjectStatus.Archived,
    ProjectStatus.Upcoming,
  ];

  form: FormGroup;

  constructor(private clientService: ClientRepository, private fb: FormBuilder) {
    this.form = fb.group({
      query: ['', null],
      client: [null, null]
    });

    this.form.get('query').valueChanges
      .debounceTime(300)
      .subscribe(q => {
        console.log(q);
        this.filters.searchString = q;
        this.changed.emit(this.filters);
      });

    this.form.get('client').valueChanges
      .subscribe(clientId => {
        this.filters.client = clientId;
        this.changed.emit(this.filters);
      });
  }

  ngOnInit() {
  }

  get clients() {
    return this.clientService.clients;
  }
}



// WEBPACK FOOTER //
// ./src/app/projects/list/project-list-filter/project-list-filter.component.ts